import builder from '../builder';
import Envelope from '../../streamline-icons/bold/envelope.svg';

export default builder('IconEnvelopeBold', Envelope);
